export enum autoRegStatuses {
  INIT = 'init',
  PAY = 'pay',
  PAY_WAITING = 'pay_waiting',
  FINISH = 'finish',
  COMPLETED = 'completed',
}
